import LayoutPrint from '@/views/print/the-layout.vue'

export default {
  path: '/cetak',
  component: LayoutPrint,
  children: [
    {
      path: 'nota/:saleId',
      name: 'print sale receipt',
      component: () => import('@/views/print/sale-receipt.vue'),
      meta: { title: 'Cetak Nota Jual' },
    },
    {
      path: 'mutasi/:moveOrderId',
      name: 'print move order sender',
      component: () => import('@/views/print/move-order-sender.vue'),
      meta: { title: 'Cetak Mutasi Barang' },
    },
    {
      path: 'penerimaan-mutasi/:moveOrderReceiptId',
      name: 'print move order receiver',
      component: () => import('@/views/print/move-order-receiver.vue'),
      meta: { title: 'Cetak Penerimaan Mutasi Barang' },
    },
    {
      path: 'alamat/:saleId',
      name: 'print sale address',
      component: () => import('@/views/print/sale-address.vue'),
      meta: { title: 'Cetak Alamat' },
    },
  ],
}
